import {type PIXI} from '@colonist/pixi'
import {type UIGameToolTipView} from './UIGameToolTipView.ts'
import {type UIGameManager} from '../UIGameManager.ts'
import {isDescendantOf} from '../../ui_utils/PixiUtils.ts'
import {type TranslationObject} from '@colonist/i18n'

export type ToolTipText = () => {title: TranslationObject, body: TranslationObject[]}

export abstract class UIGameToolTipController {
    tip: UIGameToolTipView | null = null

    protected readonly app: PIXI.Application

    constructor(uiGameManager: UIGameManager) {
        this.app = uiGameManager.canvasController.app
    }

    tipHasParent(): boolean {
        if(this.tip == null) return false
        if(this.tip.parent == undefined) return false
        return true
    }

    abstract createTip(toolTipText: ToolTipText, view: PIXI.Container)
    abstract createTipFromTooltipView(getTooltipView: () => UIGameToolTipView, view: PIXI.Container)

    disableTip(view: PIXI.Container) {
        view.interactive = false

        if(this.tip == null) return
        if(!isDescendantOf(this.tip, view)) return
        this.closeTip()
    }

    abstract openTip(toolTipText: ToolTipText, view: PIXI.Container)

    closeTip() {
        if(!this.tipHasParent() || this.tip == null) return
        this.tip.parent.removeChild(this.tip)
        this.tip = null
    }
}
